var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.list.value, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "id", width: "50" },
          }),
          _c("el-table-column", {
            attrs: { prop: "agreementName", label: "协议名称" },
          }),
          _c("el-table-column", {
            attrs: { prop: "agreementVersion", label: "协议版本" },
          }),
          _c("el-table-column", {
            attrs: { prop: "senderPlatforms", label: "发端" },
          }),
          _c("el-table-column", {
            attrs: { prop: "receiverPlatforms", label: "收端" },
          }),
          _c("el-table-column", {
            attrs: { prop: "updateTime", label: "开始时间" },
          }),
          _c("el-table-column", { attrs: { prop: "remark", label: "说明" } }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "PROTOCOL_COMPLIANCE_PROTOCOL_UPDATE_VIEW",
                            expression:
                              "'PROTOCOL_COMPLIANCE_PROTOCOL_UPDATE_VIEW'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.view(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("ElementPagination", {
        staticStyle: { "margin-bottom": "20px" },
        attrs: {
          total: _vm.searchParams.total,
          current: _vm.searchParams.current,
          size: _vm.searchParams.size,
          pageSizes: [10, 20, 100],
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c("Add", { ref: "add" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }